// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        dynamicValues: {
          y: 'height * 0.5'
        }
      }
    },
    {
      id: 'c7efac51-359c-4ecb-bf77-ac1fa0a03da7',
      type: 'Sprite',
      name: 'gradient',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: '501062e7-7115-4892-9dc3-8c61bd7030cd',
      type: 'Sprite',
      name: 'gradient2',
      className: 'dynamicProps_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 15.6,
        y: 2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'WinStreak_Blue_Gradient',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        dynamicValues: {
          width: 'width * 1.1',
          height: 'height * 1.1'
        }
      }
    },
    {
      id: 'a796708c-24ec-463d-9096-465010e0f5a2',
      type: 'Sprite',
      name: 'closeButtonShadow',
      className: '',
      x: 304,
      y: -568,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6613d803-fca4-4214-8c9e-b1c2deb75ad9',
      type: 'Sprite',
      name: 'seasonPassImage',
      className: '',
      x: 0,
      y: -229,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.4,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Image',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd05cf7c1-d890-40dc-ba41-0c7e6e3f6149',
      type: 'Container',
      name: 'rewards',
      className: '',
      x: 0,
      y: -229,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        premium: {
          visible: true,
          alpha: 1
        }
      }
    },
    {
      id: '4995526f-8680-4fcb-8acc-83a79cb5cc92',
      type: 'Container',
      name: 'moneyMountain',
      className: '',
      x: 20,
      y: -47,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '9b8f7da6-1d89-40b0-87a7-5d60eb2e9ef2',
      type: 'Container',
      name: 'premiumRewardsSlot',
      className: '',
      x: 0,
      y: -218,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'bf13c65d-19a9-4242-8b95-ab3fd74119d1',
      type: 'Text',
      name: 'getPremiumTitleText',
      className: 'colorTags_SPL',
      x: 0,
      y: -560,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Get the $Premium Pass$',
      localize: true,
      maxWidth: 530,
      maxHeight: 133,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        colorTags: {
          $: '#ffd200'
        }
      }
    },
    {
      id: '77789e65-7bad-4063-9d3d-c4ce4252c47e',
      type: 'Text',
      name: 'getPremiumDescriptionText',
      className: '',
      x: 0,
      y: -521,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'to earn up to:',
      localize: true,
      maxWidth: 700,
      maxHeight: 103,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '9e6f28c1-7b2c-4093-bcc3-a3a265b4df1e',
      type: 'Text',
      name: 'bonusTitleText',
      className: '',
      x: 0,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'BONUS',
      localize: true,
      maxWidth: 530,
      maxHeight: 60,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 4,
        dropShadowColor: 'black',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f96e674c-76ee-4b7c-bd04-f50f2ec02504',
      type: 'Text',
      name: 'bonusDescriptionText',
      className: 'colorTags_SPL',
      x: 0,
      y: 198,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Increase your $max lives$ from 5 to $8$ for the duration of the event!',
      localize: true,
      maxWidth: 500,
      maxHeight: 80,
      maxFontSize: 30,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 500,
        breakWords: false,
        lineHeight: 27,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        colorTags: {
          $: '#ffd200'
        }
      }
    },
    {
      id: '620db990-e49a-4838-a58f-f0115d7cafc7',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 304,
      y: -573,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Shop_Close_Button',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'a9f6914a-e900-45ca-a9d7-dfb13ad525b4',
      type: 'Container',
      name: 'moreLivesImage',
      className: '',
      x: 0,
      y: 134,
      scale: {
        x: 0.7,
        y: 0.7
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '7b792c00-da31-4ee7-94bb-bca41cb59a02',
      type: 'Layout',
      name: 'button',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 487,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        color: 'green',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: '9ec6906d-f06a-488d-8796-b00f75e375a7',
      type: 'Sprite',
      name: 'shine1',
      className: '',
      x: -87,
      y: -406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.05,
        y: 0.2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '88a4769e-f18b-4cfb-b2d1-d0eed362fb32',
      type: 'Sprite',
      name: 'shine2',
      className: '',
      x: 69,
      y: -304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.05,
        y: 0.2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '6e754101-bacc-4f17-85ea-ad747b4ed65d',
      type: 'Sprite',
      name: 'shine3',
      className: '',
      x: -69,
      y: -267,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.05,
        y: 0.2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'f9ff09f1-f05d-4868-b872-cb2777268ad0',
      type: 'Sprite',
      name: 'shine4',
      className: '',
      x: -210,
      y: -180,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.05,
        y: 0.2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'ed2fcce3-b340-48f1-b2ea-cf2cadf99fed',
      type: 'Sprite',
      name: 'shine5',
      className: '',
      x: 208,
      y: -153,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.05,
        y: 0.2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'a75082b2-e80d-4b6e-9ba0-0d4f586c006d',
      type: 'Sprite',
      name: 'shine6',
      className: '',
      x: -45,
      y: -114,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.05,
        y: 0.2
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Booster_Undo_Shine_Diamond',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'd6912e29-a0bf-49fa-a7ff-1cd982a6fdc0',
      type: 'Container',
      name: 'valueBadge',
      className: '',
      x: 281,
      y: -425,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 11.5,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'c19029ba-bec8-4101-9ab2-19b31c8c0976',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 5.3,
        y: 3.9
      },
      angle: 0,
      alpha: 0.5,
      visible: true,
      tint: 16578418,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: 'd05cf7c1-d890-40dc-ba41-0c7e6e3f6149'
    },
    {
      id: 'e72537d0-a4a3-400f-ae00-414a006fa3ec',
      type: 'Sprite',
      name: '',
      className: 'rotate_SPL',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.8,
        y: 1.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'd05cf7c1-d890-40dc-ba41-0c7e6e3f6149'
    },
    {
      id: '35c7d7c1-80d3-4db5-a573-1013e3dda108',
      type: 'Sprite',
      name: '',
      className: '',
      x: 74,
      y: -274,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16759682,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'bac26f55-b248-4cbf-bb55-38c490a284e2',
      type: 'Sprite',
      name: '',
      className: '',
      x: 113,
      y: -213,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.221025,
        y: 1.221025
      },
      angle: 4,
      alpha: 1,
      visible: true,
      tint: 16759682,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '00c4d5ff-b618-4518-8d01-b00f52207e9f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -355,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Gold',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'ffd8df76-f7bf-45bc-9160-1acfd7d06a0a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 63,
      y: -250,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '90b330df-c9a3-41d2-83fe-d4babd633adb',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -264,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: 20,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Heart',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'c8ceb35e-ce8f-472c-92ea-d966488026a3',
      type: 'Sprite',
      name: '',
      className: '',
      x: -71,
      y: -271,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '3f7905a2-3280-4f3f-8767-6a8d9527bde1',
      type: 'Sprite',
      name: '',
      className: '',
      x: -13,
      y: -204,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16759682,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '2f187b8c-56a1-450f-bac2-8f1a7857370b',
      type: 'Sprite',
      name: '',
      className: '',
      x: -43,
      y: -159,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '89a2fb1b-1bb0-406b-9386-ce68dbfca4aa',
      type: 'Sprite',
      name: '',
      className: '',
      x: 165,
      y: -150,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16759682,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'be352fac-5f22-4237-9d21-2ad9f5c87adb',
      type: 'Sprite',
      name: '',
      className: '',
      x: 125,
      y: -238,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: 28,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '07fd650c-70bb-412b-a38f-88383a09c654',
      type: 'Sprite',
      name: '',
      className: '',
      x: 63,
      y: -223,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '444be333-0032-4bdc-b4de-984151ffb776',
      type: 'Sprite',
      name: '',
      className: '',
      x: -1,
      y: -193,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'a4e6be4e-5b07-4140-9138-87f8ebad113a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -143,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '6a2b2efa-5bf6-4065-a49f-ad6adcba5e12',
      type: 'Sprite',
      name: '',
      className: '',
      x: -154,
      y: -121,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16759682,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '65ee7f44-3ed4-4c09-a038-4ecc8cca34be',
      type: 'Sprite',
      name: '',
      className: '',
      x: -124,
      y: -207,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: -6,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Event_Chest_Silver',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '75f58100-cba5-418e-8b61-ec50ae6abde7',
      type: 'Sprite',
      name: '',
      className: '',
      x: -76,
      y: -119,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '7944c0ff-8f85-4f7a-8ba0-dcea8fe547cb',
      type: 'Sprite',
      name: '',
      className: '',
      x: -196,
      y: -117,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.4,
        y: 0.4
      },
      angle: -62.9,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Swap_Booster',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'd129aa2e-b671-4a9d-b999-023d77337367',
      type: 'Sprite',
      name: '',
      className: '',
      x: -189,
      y: -93,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'cf9d1c5a-8693-42a6-ac93-600f3482c37f',
      type: 'Sprite',
      name: '',
      className: '',
      x: 97,
      y: -165,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 4,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Chest_Bronze',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '85107778-be1b-4369-9f62-4662d6de52e0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 35,
      y: -94,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'bbf0b1eb-1952-47b8-8e04-8e284c5b640a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 100,
      y: -113,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.34,
        y: 0.34
      },
      angle: -68,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Hammer_Booster',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '01c74605-a250-4919-84aa-7956d9b5449a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 166,
      y: -98,
      anchor: {
        x: 0.3,
        y: 0.6
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'b68630e0-ed48-464a-8935-c8b98ec51caf',
      type: 'Sprite',
      name: '',
      className: '',
      x: -14,
      y: -82,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.105,
        y: 1.105
      },
      angle: 2,
      alpha: 1,
      visible: true,
      tint: 16759682,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins_5',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '067b02cb-221c-4b5a-9b91-5ddefe718cb0',
      type: 'Sprite',
      name: '',
      className: '',
      x: -15,
      y: -78,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.5,
        y: 0.5
      },
      angle: -32.3,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Heart',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '25207600-2bb3-4c4d-a8f9-97652bb8bdfd',
      type: 'Sprite',
      name: '',
      className: '',
      x: -87,
      y: -66,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: '5c78121e-fbe5-4030-92b1-d0c3ebb57061',
      type: 'Sprite',
      name: '',
      className: '',
      x: 135,
      y: -82,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Coins',
      parent: '4995526f-8680-4fcb-8acc-83a79cb5cc92'
    },
    {
      id: 'b8edb64c-e3f6-4295-b200-466b4f84d211',
      type: 'Sprite',
      name: 'glow1',
      className: '',
      x: 0,
      y: 260,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 3.043478,
        y: 1.304348
      },
      angle: 0,
      alpha: 0.7,
      visible: true,
      tint: 31176,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Circle_Glow',
      parent: 'a9f6914a-e900-45ca-a9d7-dfb13ad525b4'
    },
    {
      id: '39570a08-8437-433e-b5b6-416425392883',
      type: 'Sprite',
      name: 'splash',
      className: '',
      x: 84,
      y: 265,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Splash',
      parent: 'a9f6914a-e900-45ca-a9d7-dfb13ad525b4'
    },
    {
      id: '923d269a-ecf8-4918-a3e0-7797490188f3',
      type: 'Sprite',
      name: 'arrow',
      className: '',
      x: -109,
      y: 266,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -53.8,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Arrow',
      parent: 'a9f6914a-e900-45ca-a9d7-dfb13ad525b4'
    },
    {
      id: '7b154819-739c-46e4-a3e5-84d546d11968',
      type: 'Sprite',
      name: 'heart',
      className: '',
      x: -137,
      y: 287,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.6,
        y: 0.6
      },
      angle: -15,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: 'a9f6914a-e900-45ca-a9d7-dfb13ad525b4'
    },
    {
      id: '4efe278a-9189-4356-9fa6-199cdfa98339',
      type: 'Sprite',
      name: 'heart2',
      className: '',
      x: 102,
      y: 276,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -15,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: 'a9f6914a-e900-45ca-a9d7-dfb13ad525b4'
    },
    {
      id: '8cf3e25e-85cf-4725-b3b0-bb4c913e66b5',
      type: 'Sprite',
      name: 'buttonGlow',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 2.112069,
        y: 0.538793
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'circle_128_blur',
      parent: '7b792c00-da31-4ee7-94bb-bca41cb59a02'
    },
    {
      id: '9558802f-63e2-413d-b542-677e81abafef',
      type: 'Text',
      name: 'price',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '$XX:XX',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 60,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#006100',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7b792c00-da31-4ee7-94bb-bca41cb59a02'
    },
    {
      id: '327ae1f8-6b12-4364-81a4-8b2890d430eb',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Value_Badge_Red',
      parent: 'd6912e29-a0bf-49fa-a7ff-1cd982a6fdc0'
    },
    {
      id: '5b981b1a-42aa-494d-bce0-0e5484e5d2c0',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'badge_up to',
      localize: true,
      maxWidth: 116,
      maxHeight: 53,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd6912e29-a0bf-49fa-a7ff-1cd982a6fdc0'
    },
    {
      id: '40781422-1076-4e1d-8e72-1c1475821333',
      type: 'Text',
      name: '',
      className: 'variable_SPL',
      x: 0,
      y: -7,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '<seasonPass.valueBadgeAmount>',
      localize: false,
      maxWidth: 121,
      maxHeight: 69,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 58,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd6912e29-a0bf-49fa-a7ff-1cd982a6fdc0'
    },
    {
      id: 'a7c5ded1-4608-4c6c-be3c-3fb34785628a',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 31,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'badge_value',
      localize: true,
      maxWidth: 109,
      maxHeight: 44,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 5,
        dropShadowColor: 'black',
        dropShadowDistance: 0,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'd6912e29-a0bf-49fa-a7ff-1cd982a6fdc0'
    },
    {
      id: 'dd5cf0ea-6f28-42c3-b651-4891d81ce8e4',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Infinity_Symbol_Big',
      parent: '90b330df-c9a3-41d2-83fe-d4babd633adb'
    },
    {
      id: '5b0bd0d7-1fcc-44aa-b4f1-fd9c5710a493',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -16,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Infinity_Symbol_Big',
      parent: '067b02cb-221c-4b5a-9b91-5ddefe718cb0'
    },
    {
      id: '376d2c3e-924a-45cc-958d-34500ccfcad1',
      type: 'Text',
      name: '5',
      className: '',
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '5',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 130,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#730027',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '7b154819-739c-46e4-a3e5-84d546d11968'
    },
    {
      id: 'ddf0899e-8e94-4dd7-a4e9-98a5614cf842',
      type: 'Sprite',
      name: 'heartShine',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: '4efe278a-9189-4356-9fa6-199cdfa98339'
    },
    {
      id: 'df557c64-a909-4300-9461-06442459ce4c',
      type: 'Text',
      name: '8',
      className: '',
      x: 0,
      y: -15,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '8',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 130,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#730027',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '4efe278a-9189-4356-9fa6-199cdfa98339'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  animations: [
    {
      id: 'f5d55998-bed9-434d-a9e8-fcbf38284822',
      name: 'Appearing',
      playingSpeed: 1,
      totalDuration: 600,
      blocks: [
        {
          id: '4ae5c4fd-bd9d-4345-b2e0-f93cd6e7264f',
          type: 'Setter',
          name: 'gradientAlpha',
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'gradient',
          disabled: false
        },
        {
          id: '2e829c7a-4443-4bdc-8571-a5140d2fe9dd',
          type: 'Setter',
          name: 'seasonPassImageAlpha',
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'seasonPassImage',
          disabled: false
        },
        {
          id: 'a8db1637-db68-4479-a837-155b405804c1',
          type: 'Setter',
          name: 'floorAlpha',
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'floor',
          disabled: false
        },
        {
          id: 'f6bf6225-f3df-4d5e-a7aa-7c056c6c8b96',
          type: 'Setter',
          name: 'raysAlpha',
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'rays',
          disabled: false
        },
        {
          id: 'c26af567-daa3-4537-aa12-37c671ba7091',
          type: 'Setter',
          name: 'glowAlpha',
          track: 7,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'glow2',
          disabled: false
        },
        {
          id: '742f58dc-c9a9-497a-810f-e3e47b7cce42',
          type: 'Setter',
          name: 'premiumTitleAlpha',
          track: 14,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'getPremiumTitleText',
          disabled: false
        },
        {
          id: 'ba8d9be5-845a-4123-affa-48cc98a16286',
          type: 'Setter',
          name: 'premiumDescriptionAlpha_copy',
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'getPremiumDescriptionText',
          disabled: false
        },
        {
          id: '0d6c17cd-25aa-4ae0-aa6d-b86434473424',
          type: 'Setter',
          name: 'bonusTitleAlpha',
          track: 11,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'bonusTitleText',
          disabled: false
        },
        {
          id: '4c8dcdd4-b682-4a17-a206-fd429cdb8e28',
          type: 'Setter',
          name: 'bonusDescriptionAlpha_copy',
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'bonusDescriptionText',
          disabled: false
        },
        {
          id: 'a8675b9e-26ed-4fcc-b65c-c56a17edf3e7',
          type: 'Setter',
          name: 'moneyScalePosition',
          track: 18,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'moneyMountain',
          disabled: false
        },
        {
          id: 'd63dd781-5755-403e-99de-f7ecdb43e973',
          type: 'Setter',
          name: 'livesScalePosition_copy',
          track: 16,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'moreLivesImage',
          disabled: false
        },
        {
          id: 'cf49aafe-3c39-4c8f-ae8a-035efd194b34',
          type: 'Setter',
          name: 'closeButtonScale',
          track: 23,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          disabled: false
        },
        {
          id: 'b880ed98-2b57-44cb-8954-d06b82fd9793',
          type: 'Setter',
          name: 'closeButtonShadowScale_copy',
          track: 20,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'closeButtonShadow',
          disabled: false
        },
        {
          id: '109d7936-0427-4c1b-8d9a-876f500dab2d',
          type: 'Setter',
          name: 'closeButtonScale_copy',
          track: 22,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'button',
          disabled: false
        },
        {
          id: '0937aec1-177d-4a33-b5c0-8f76ea778fee',
          type: 'Setter',
          name: 'floorAlpha_copy',
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'floor2',
          disabled: false
        },
        {
          id: '8fd755ea-6b5b-407d-a458-234feccc71d5',
          type: 'Setter',
          name: 'gradientAlpha_copy',
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'gradient2',
          disabled: false
        },
        {
          id: 'be05914e-ae4e-48ed-b40f-626d885d122f',
          type: 'Setter',
          name: 'rewardsAlpha',
          track: 24,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'rewards',
          disabled: false
        },
        {
          id: 'e6e6a32f-a59d-4434-a1eb-b3be41b4df36',
          type: 'Setter',
          name: 'rewardsSlot',
          track: 25,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'premiumRewardsSlot',
          disabled: false
        },
        {
          id: 'cc16b94a-aa08-43d7-880b-029a86a05e0d',
          type: 'Setter',
          name: 'valueBadgeSetter',
          track: 26,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'valueBadge',
          disabled: false
        },
        {
          id: 'f5b9d23b-9bad-4675-8a51-01d21030a2d3',
          type: 'Tween',
          name: 'gradientAlpha_1',
          duration: 290,
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'gradient',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '72e29db8-5721-40ba-b04b-688d33c082c4',
          type: 'Tween',
          name: 'gradientAlpha_1_copy',
          duration: 290,
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 10,
          sourceName: 'gradient2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '11e188a0-b236-42e0-a346-d3f52631ea5c',
          type: 'Tween',
          name: 'floorAlpha_1',
          duration: 300,
          track: 9,
          target: {
            alpha: 1
          },
          startAt: 100,
          sourceName: 'floor',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0e344d9f-9cf6-4189-85f1-f6aad5f014ce',
          type: 'Tween',
          name: 'seasonPassImageAlpha',
          duration: 300,
          track: 3,
          target: {
            alpha: 0.4
          },
          startAt: 100,
          sourceName: 'seasonPassImage',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '87105c00-9f56-43ca-9af9-0fbcc2eef85b',
          type: 'Tween',
          name: 'floorAlpha_1_copy_1',
          duration: 300,
          track: 8,
          target: {
            alpha: 0.3
          },
          startAt: 100,
          sourceName: 'floor2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f267b06b-b85c-4a7d-9cfa-9a82773fc9b7',
          type: 'Tween',
          name: 'moneyScalePosition_1',
          duration: 200,
          track: 18,
          target: {
            scale: {
              x: 1.04,
              y: 1.08
            }
          },
          startAt: 150,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '401b0394-050a-4264-bd8b-21c92bed9a2b',
          type: 'Tween',
          name: 'glow2Alpha_1',
          duration: 300,
          track: 7,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'glow2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c553c725-507e-47b8-bb70-8485d657b10b',
          type: 'Tween',
          name: 'raysAlpha_1',
          duration: 300,
          track: 5,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'rays',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7d0e3356-70c7-46e3-9e38-bd5471057eae',
          type: 'Tween',
          name: 'premiumTitleAlpha_1',
          duration: 300,
          track: 14,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'getPremiumTitleText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ff4cb1e4-5ac7-474c-a263-9ff5e1496c59',
          type: 'Tween',
          name: 'premiumDescriptionAlpha_1_copy',
          duration: 300,
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'getPremiumDescriptionText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '34dedf97-2ed1-45d8-8a5a-0aac8f6d538e',
          type: 'Tween',
          name: 'bonusTitleAlpha_1',
          duration: 300,
          track: 11,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'bonusTitleText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '675f84cd-1da6-42be-9304-e0556eaae8e6',
          type: 'Tween',
          name: 'bonusDescriptionAlpha',
          duration: 300,
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 150,
          sourceName: 'bonusDescriptionText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c7563056-c8fa-468d-b1b2-5bd69f57e657',
          type: 'Tween',
          name: 'livesScalePosition_1_copy_1',
          duration: 200,
          track: 16,
          target: {
            scale: {
              x: 0.728,
              y: 0.756
            }
          },
          startAt: 150,
          sourceName: 'moreLivesImage',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'dbdba74c-d2bb-46d0-b7bc-8cc379a9d0c1',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 400,
          track: 25,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 198,
          sourceName: 'premiumRewardsSlot',
          easing: 'ElasticOut',
          disabled: false
        },
        {
          id: 'ac097a47-eb6d-462c-8d6f-e29ee925a52a',
          type: 'Tween',
          name: 'New_tween',
          duration: 400,
          track: 24,
          target: {
            alpha: 1
          },
          startAt: 200,
          sourceName: 'rewards',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '38709eb6-f330-473a-8e37-f224350a9525',
          type: 'Tween',
          name: 'closeButtonScale_1_1',
          duration: 200,
          track: 23,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 200,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c742c130-b5a3-437a-881a-722f1bf9df9b',
          type: 'Tween',
          name: 'closeButtonShadowScale_1_1_copy_1',
          duration: 200,
          track: 20,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 200,
          sourceName: 'closeButtonShadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7700f97a-9dbc-494f-b190-24378b89824e',
          type: 'Tween',
          name: 'ButtonScale_1_1_copy_1',
          duration: 200,
          track: 22,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 200,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '86f9c5e6-349e-4284-b110-8b4dbd627595',
          type: 'Tween',
          name: 'livesScalePosition_1_copy_1_copy',
          duration: 200,
          track: 16,
          target: {
            scale: {
              x: 0.7,
              y: 0.7
            }
          },
          startAt: 350,
          sourceName: 'moreLivesImage',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd19ea611-8a68-4c9c-9ac9-5f5c6da25831',
          type: 'Tween',
          name: 'moneyScalePosition_1_copy',
          duration: 200,
          track: 18,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 350,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '93669786-e99b-4fdc-8f67-0e6e5760d97e',
          type: 'Tween',
          name: 'New_tween_3_1',
          duration: 200,
          track: 26,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'valueBadge',
          easing: 'CubicOut',
          disabled: false
        },
        {
          id: '23fb919c-f97e-45a0-9b73-f0466abc109d',
          type: 'Tween',
          name: 'ButtonScale_1_1_copy_1_copy',
          duration: 200,
          track: 22,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9a586ccc-0d54-4503-8b16-abf5e7a8aa53',
          type: 'Tween',
          name: 'closeButtonShadowScale_1_1_copy_1_copy',
          duration: 200,
          track: 20,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'closeButtonShadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6b52a50b-ae40-45ea-8ae8-5fd2fce02706',
          type: 'Tween',
          name: 'closeButtonScale_1_1_copy',
          duration: 200,
          track: 23,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 400,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '57f9d7fd-4c33-43d4-bbfe-433dd12d33db',
          type: 'Tween',
          name: 'closeButtonShadowScale_1_1_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1542,
          sourceName: 'closeButtonShadow',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    },
    {
      id: 'd7217f43-5ea2-4f00-923d-e891e5bb3c38',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 4000,
      blocks: [
        {
          id: '8797a2ac-5a65-4e75-a5dd-990f615b4029',
          type: 'Tween',
          name: 'moneyScalePosition_2',
          duration: 1000,
          track: 18,
          target: {
            scale: {
              x: 1.01,
              y: 1.005
            }
          },
          startAt: 0,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '210a547a-7c8a-4f39-8838-28b0a2b79cf3',
          type: 'Tween',
          name: 'buttonScale',
          duration: 1000,
          track: 14,
          target: {
            scale: {
              x: 1.06,
              y: 1.06
            }
          },
          startAt: 0,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '8ad2bbaa-a551-44d6-b56a-e554055d19ce',
          type: 'Tween',
          name: 'buttonGlowAlpha',
          duration: 1000,
          track: 13,
          target: {
            alpha: 0.3
          },
          startAt: 0,
          sourceName: 'buttonGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4ddbe472-1d07-4370-b6cd-5a34b587662b',
          type: 'Setter',
          name: 'shine6AlphaScale',
          track: 12,
          target: {
            alpha: 1,
            scale: {
              y: 0.2
            }
          },
          startAt: 100,
          sourceName: 'shine6',
          disabled: false
        },
        {
          id: '5e235f7c-88dc-48f2-9bea-cb496394a295',
          type: 'Tween',
          name: 'shine6AlphaScale_1',
          duration: 200,
          track: 12,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 110,
          sourceName: 'shine6',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '71be26f7-7fab-4f70-8a41-b306d6ad7560',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_1',
          track: 12,
          target: {
            alpha: 0,
            scale: {
              y: 0.2
            }
          },
          startAt: 310,
          sourceName: 'shine6',
          disabled: false
        },
        {
          id: '4a06f232-017b-44f9-8554-2b8e3323cd22',
          type: 'Setter',
          name: 'shine5AlphaScale_copy',
          track: 10,
          target: {
            alpha: 1,
            scale: {
              y: 0.2
            }
          },
          startAt: 500,
          sourceName: 'shine5',
          disabled: false
        },
        {
          id: '5d572f49-15c4-4b7c-8165-b09f931b09e6',
          type: 'Tween',
          name: 'shine5AlphaScale_1_copy',
          duration: 200,
          track: 10,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 510,
          sourceName: 'shine5',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '343fc9c7-a6df-47cf-8682-ca0085e8d4f1',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_1_copy',
          track: 10,
          target: {
            alpha: 0,
            scale: {
              y: 0.2
            }
          },
          startAt: 710,
          sourceName: 'shine5',
          disabled: false
        },
        {
          id: 'f3f6bccf-8ef8-44d0-b161-f07a3e8b6d41',
          type: 'Setter',
          name: 'shine4AlphaScale_copy_copy',
          track: 8,
          target: {
            alpha: 1,
            scale: {
              y: 0.2
            }
          },
          startAt: 900,
          sourceName: 'shine4',
          disabled: false
        },
        {
          id: '55030f3c-5cb6-435f-b959-0ff6672bd0df',
          type: 'Tween',
          name: 'shine4AlphaScale_1_copy_copy',
          duration: 200,
          track: 8,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 910,
          sourceName: 'shine4',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'b6f42d68-0ca8-49a2-8b54-64c21455a3bc',
          type: 'Tween',
          name: 'buttonGlowAlpha_copy',
          duration: 1000,
          track: 13,
          target: {
            alpha: 0
          },
          startAt: 1000,
          sourceName: 'buttonGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ec3ae961-597a-49c6-bfb1-50d9b80e6173',
          type: 'Tween',
          name: 'buttonScale_copy',
          duration: 1000,
          track: 14,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1eb56d5d-9b57-4e62-9252-35eb1a662862',
          type: 'Tween',
          name: 'moneyScalePosition_2_copy',
          duration: 1000,
          track: 18,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1000,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0ce50e4d-8f1e-4194-99c3-6c2731975e95',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_1_copy_copy',
          track: 8,
          target: {
            alpha: 0,
            scale: {
              y: 0.2
            }
          },
          startAt: 1110,
          sourceName: 'shine4',
          disabled: false
        },
        {
          id: '49f9c1ed-366d-4941-a6a9-131a96d98dca',
          type: 'Setter',
          name: 'shine3AlphaScale_copy_copy_copy',
          track: 6,
          target: {
            alpha: 1,
            scale: {
              y: 0.2
            }
          },
          startAt: 1200,
          sourceName: 'shine3',
          disabled: false
        },
        {
          id: '68cb11f0-9bfa-464f-a3d5-19d550a7984d',
          type: 'Tween',
          name: 'shine3AlphaScale_1_copy_copy_copy',
          duration: 200,
          track: 6,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1210,
          sourceName: 'shine3',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '8c3cce61-63df-4227-863b-1bbea5195548',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_1_copy_copy_copy',
          track: 6,
          target: {
            alpha: 0,
            scale: {
              y: 0.2
            }
          },
          startAt: 1410,
          sourceName: 'shine3',
          disabled: false
        },
        {
          id: '3632613e-2087-47a7-a6b2-b05631091f6d',
          type: 'Setter',
          name: 'shine2AlphaScale_copy_copy_copy_copy',
          track: 4,
          target: {
            alpha: 1,
            scale: {
              y: 0.2
            }
          },
          startAt: 1500,
          sourceName: 'shine2',
          disabled: false
        },
        {
          id: 'f9dbb8af-ba4a-4291-9a2c-babc6851e737',
          type: 'Tween',
          name: 'shine2AlphaScale_1_copy_copy_copy_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1510,
          sourceName: 'shine2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '499e4c0c-836a-41c9-8892-11b59c1c844e',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_1_copy_copy_copy_copy',
          track: 4,
          target: {
            alpha: 0,
            scale: {
              y: 0.2
            }
          },
          startAt: 1710,
          sourceName: 'shine2',
          disabled: false
        },
        {
          id: 'e41bcd07-4029-4985-9db9-1d9530c40ce7',
          type: 'Setter',
          name: 'shine1AlphaScale_copy_copy_copy_copy_copy',
          track: 2,
          target: {
            alpha: 1,
            scale: {
              y: 0.2
            }
          },
          startAt: 1800,
          sourceName: 'shine1',
          disabled: false
        },
        {
          id: '9cc33bab-6529-411b-87d7-999d06a230ea',
          type: 'Tween',
          name: 'shine1AlphaScale_1_copy_copy_copy_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 1810,
          sourceName: 'shine1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f31fc65c-13a4-4896-860e-88076cdeb857',
          type: 'Tween',
          name: 'buttonGlowAlpha_copy_1',
          duration: 1000,
          track: 13,
          target: {
            alpha: 0.3
          },
          startAt: 2000,
          sourceName: 'buttonGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6f772ff6-c011-4157-95c4-5c3589b33672',
          type: 'Tween',
          name: 'buttonScale_copy_1',
          duration: 1000,
          track: 14,
          target: {
            scale: {
              x: 1.06,
              y: 1.06
            }
          },
          startAt: 2000,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f746afea-aaac-47d0-83de-8bdd5c05c0c6',
          type: 'Tween',
          name: 'heartScale_3',
          duration: 500,
          track: 17,
          target: {
            scale: {
              x: 0.83,
              y: 0.82
            }
          },
          startAt: 2000,
          sourceName: 'heart2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'e2b1ad67-c42b-4d01-b845-50647e1db1cf',
          type: 'Tween',
          name: 'heartShineAlpha',
          duration: 500,
          track: 16,
          target: {
            alpha: 0.4
          },
          startAt: 2000,
          sourceName: 'heartShine',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '29bcc731-e6e0-4a8f-9292-c317d74c1218',
          type: 'Tween',
          name: 'moneyScalePosition_2_copy_1',
          duration: 1000,
          track: 18,
          target: {
            scale: {
              x: 1.01,
              y: 1.005
            }
          },
          startAt: 2000,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '716a139d-1d87-4332-b15f-1e0762231a8a',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_1_copy_copy_copy_copy_copy',
          track: 2,
          target: {
            alpha: 0,
            scale: {
              y: 0.2
            }
          },
          startAt: 2010,
          sourceName: 'shine1',
          disabled: false
        },
        {
          id: 'dacb6d83-3ff8-4cb8-b2c4-dfcdf665964b',
          type: 'Setter',
          name: 'shine6AlphaScale_copy',
          track: 11,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 1
          },
          startAt: 2100,
          sourceName: 'shine6',
          disabled: false
        },
        {
          id: '30f64bba-9a1d-4c9f-a0d0-a86913771300',
          type: 'Tween',
          name: 'shine6AlphaScale_1_copy',
          duration: 200,
          track: 11,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 2110,
          sourceName: 'shine6',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '7d670eb9-0f58-404e-bccd-f3b73a562851',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_copy',
          track: 11,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 0
          },
          startAt: 2310,
          sourceName: 'shine6',
          disabled: false
        },
        {
          id: '0695d4a4-d2bd-4dd9-b241-c22682102fa6',
          type: 'Setter',
          name: 'shine5AlphaScale_copy_copy',
          track: 9,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 1
          },
          startAt: 2500,
          sourceName: 'shine5',
          disabled: false
        },
        {
          id: 'c421d64e-ef52-4141-8000-95c898e98007',
          type: 'Tween',
          name: 'heartScale_1',
          duration: 500,
          track: 17,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 2500,
          sourceName: 'heart2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '915e8a6a-07f0-4cd8-bd3a-1e0eaab45381',
          type: 'Tween',
          name: 'heartShineAlpha_copy',
          duration: 500,
          track: 16,
          target: {
            alpha: 0
          },
          startAt: 2500,
          sourceName: 'heartShine',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4061c81b-b92f-4043-9427-6782f8831560',
          type: 'Tween',
          name: 'shine5AlphaScale_1_copy_copy',
          duration: 200,
          track: 9,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 2510,
          sourceName: 'shine5',
          easing: 'Linear',
          disabled: false
        },
        {
          id: 'f418aa77-0137-4877-8951-d97471db4b87',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_copy_copy',
          track: 9,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 0
          },
          startAt: 2710,
          sourceName: 'shine5',
          disabled: false
        },
        {
          id: '4bff6669-a3fa-4613-b0f9-678c7422d45c',
          type: 'Setter',
          name: 'shine4AlphaScale_copy_copy_copy',
          track: 7,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 1
          },
          startAt: 2900,
          sourceName: 'shine4',
          disabled: false
        },
        {
          id: '9d7ca8f5-e802-40b3-afe4-b7f8141a8bdb',
          type: 'Tween',
          name: 'shine4AlphaScale_1_copy_copy_copy',
          duration: 200,
          track: 7,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 2910,
          sourceName: 'shine4',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '4b9c1c28-ec6b-4db0-9656-92b72e6e9828',
          type: 'Tween',
          name: 'buttonGlowAlpha_copy_copy',
          duration: 1000,
          track: 13,
          target: {
            alpha: 0
          },
          startAt: 3000,
          sourceName: 'buttonGlow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b414fd76-8ea4-435a-a3b7-aa0bcf860d02',
          type: 'Tween',
          name: 'buttonScale_copy_copy',
          duration: 1000,
          track: 14,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 3000,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '75c13130-1442-4e85-a934-67cfd02f5db0',
          type: 'Tween',
          name: 'heartScale',
          duration: 500,
          track: 17,
          target: {
            scale: {
              x: 0.83,
              y: 0.82
            }
          },
          startAt: 3000,
          sourceName: 'heart2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '4c995f38-7a66-49cb-9298-b69c1c68a547',
          type: 'Tween',
          name: 'heartShineAlpha_copy_1',
          duration: 500,
          track: 16,
          target: {
            alpha: 0.4
          },
          startAt: 3000,
          sourceName: 'heartShine',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '56fb3384-3659-4e62-9d81-64df6beaa1c6',
          type: 'Tween',
          name: 'moneyScalePosition_2_copy_copy',
          duration: 1000,
          track: 18,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 3000,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '2468c34f-41ca-4339-9c26-1c17e05bd8fc',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_copy_copy_copy',
          track: 7,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 0
          },
          startAt: 3110,
          sourceName: 'shine4',
          disabled: false
        },
        {
          id: '4a0c2731-434e-463a-9182-451ea558c47a',
          type: 'Setter',
          name: 'shine3AlphaScale_copy_copy_copy_copy',
          track: 5,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 1
          },
          startAt: 3200,
          sourceName: 'shine3',
          disabled: false
        },
        {
          id: 'a4ae192b-ede1-4b53-9a16-fc14380d0e29',
          type: 'Tween',
          name: 'shine3AlphaScale_1_copy_copy_copy_copy',
          duration: 200,
          track: 5,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 3210,
          sourceName: 'shine3',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '0a78210c-d1c5-4628-83ec-b731e3d4a20b',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_copy_copy_copy_copy',
          track: 5,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 0
          },
          startAt: 3410,
          sourceName: 'shine3',
          disabled: false
        },
        {
          id: 'd3616293-ed99-4910-a363-afeab1a9a030',
          type: 'Setter',
          name: 'shine2AlphaScale_copy_copy_copy_copy_copy',
          track: 3,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 1
          },
          startAt: 3500,
          sourceName: 'shine2',
          disabled: false
        },
        {
          id: '1aa80362-e091-4af9-a2e7-dbe670f0cc40',
          type: 'Tween',
          name: 'heartScale_2',
          duration: 500,
          track: 17,
          target: {
            scale: {
              x: 0.8,
              y: 0.8
            }
          },
          startAt: 3500,
          sourceName: 'heart2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'a0bc41f4-5b3b-46b7-84cb-955d908c6e88',
          type: 'Tween',
          name: 'heartShineAlpha_copy_copy',
          duration: 500,
          track: 16,
          target: {
            alpha: 0
          },
          startAt: 3500,
          sourceName: 'heartShine',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'aa6b54f3-84fc-4db1-b579-a35af159e080',
          type: 'Tween',
          name: 'shine2AlphaScale_1_copy_copy_copy_copy_copy',
          duration: 200,
          track: 3,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 3510,
          sourceName: 'shine2',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '35e4e439-1f1b-4bc5-8aab-6e538e293679',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_copy_copy_copy_copy_copy',
          track: 3,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 0
          },
          startAt: 3710,
          sourceName: 'shine2',
          disabled: false
        },
        {
          id: '289f514e-e456-448f-b8ae-c63ecc426d40',
          type: 'Setter',
          name: 'shine1AlphaScale_copy_copy_copy_copy_copy_copy',
          track: 1,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 1
          },
          startAt: 3750,
          sourceName: 'shine1',
          disabled: false
        },
        {
          id: '236bdb62-51c6-48e4-8ed2-d39e8da84715',
          type: 'Tween',
          name: 'shine1AlphaScale_1_copy_copy_copy_copy_copy_copy',
          duration: 200,
          track: 1,
          target: {
            scale: {
              y: 0
            }
          },
          startAt: 3760,
          sourceName: 'shine1',
          easing: 'Linear',
          disabled: false
        },
        {
          id: '91af13ea-da96-4aa2-b1d1-ab22c83fdb92',
          type: 'Setter',
          name: 'shine6AlphaScale_copy_copy_copy_copy_copy_copy_copy',
          track: 1,
          target: {
            scale: {
              y: 0.2
            },
            alpha: 0
          },
          startAt: 3960,
          sourceName: 'shine1',
          disabled: false
        }
      ]
    },
    {
      id: 'bbf2671d-20f4-4a1f-8fbd-b92a767eff0e',
      name: 'Disappearing',
      playingSpeed: 1,
      totalDuration: 600,
      blocks: [
        {
          id: '12dcf499-7949-42a6-937e-3e2d6055174f',
          type: 'Setter',
          name: 'gradientAlpha',
          track: 2,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'gradient',
          disabled: false
        },
        {
          id: '2126b693-e546-41e1-a19b-0c019bf6c970',
          type: 'Setter',
          name: 'New_setter_copy',
          track: 10,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'floor',
          disabled: false
        },
        {
          id: '6ea46bf9-e729-446d-9ed8-0d757bb634a7',
          type: 'Setter',
          name: 'glow2Alpha',
          track: 8,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'glow2',
          disabled: false
        },
        {
          id: '418787b3-d99a-44c9-9db0-a9b402c3af42',
          type: 'Setter',
          name: 'seasonPassImageAlpha',
          track: 3,
          target: {
            alpha: 0.4
          },
          startAt: 0,
          sourceName: 'seasonPassImage',
          disabled: false
        },
        {
          id: 'ba637c01-5fe2-4035-a561-919371d62656',
          type: 'Setter',
          name: 'raysAlpha',
          track: 5,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'rays',
          disabled: false
        },
        {
          id: '44af526d-044f-4847-917c-926b9a52601e',
          type: 'Setter',
          name: 'New_setter_copy_copy_1',
          track: 11,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'bonusDescriptionText',
          disabled: false
        },
        {
          id: '04236350-cb80-458e-8d15-49010c6f872b',
          type: 'Setter',
          name: 'New_setter_copy_copy_2',
          track: 12,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'bonusTitleText',
          disabled: false
        },
        {
          id: '83daf4b3-2b71-42a8-92ad-c89a3e30ba36',
          type: 'Setter',
          name: 'New_setter_copy_copy_3',
          track: 13,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'getPremiumDescriptionText',
          disabled: false
        },
        {
          id: 'bd030477-dd81-4aa7-83c7-c5c2b3f9c5f6',
          type: 'Setter',
          name: 'New_setter_copy_copy_4',
          track: 15,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'getPremiumTitleText',
          disabled: false
        },
        {
          id: '9956ff19-9054-4e7c-bda0-2eeaedc2a3bd',
          type: 'Setter',
          name: 'floor2Alpha',
          track: 9,
          target: {
            alpha: 0.3
          },
          startAt: 0,
          sourceName: 'floor2',
          disabled: false
        },
        {
          id: 'b73d2f9b-db7a-43f8-af0b-3e59728a8ebc',
          type: 'Setter',
          name: 'gradientAlpha_copy_1',
          track: 1,
          target: {
            alpha: 1
          },
          startAt: 0,
          sourceName: 'gradient2',
          disabled: false
        },
        {
          id: 'c742c130-b5a3-437a-881a-722f1bf9df9b',
          type: 'Tween',
          name: 'closeButtonShadowScale_1_1_copy_1',
          duration: 200,
          track: 21,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'closeButtonShadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7700f97a-9dbc-494f-b190-24378b89824e',
          type: 'Tween',
          name: 'ButtonScale_1_1_copy_1',
          duration: 200,
          track: 23,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '38709eb6-f330-473a-8e37-f224350a9525',
          type: 'Tween',
          name: 'closeButtonScale_1_1',
          duration: 200,
          track: 24,
          target: {
            scale: {
              x: 1.05,
              y: 1.05
            }
          },
          startAt: 0,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '204f92a9-c825-443b-b5a4-35a038f436bd',
          type: 'Tween',
          name: 'New_tween_2',
          duration: 300,
          track: 27,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'rewards',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: '04c0964e-2da7-4e41-b0cd-4283ec4d162d',
          type: 'Tween',
          name: 'New_tween_2_copy_1',
          duration: 300,
          track: 26,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 0,
          sourceName: 'premiumRewardsSlot',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: 'd8fab682-279d-48f8-bdf6-5fac8bf20906',
          type: 'Tween',
          name: 'New_tween_2_copy',
          duration: 300,
          track: 25,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 1,
          sourceName: 'valueBadge',
          easing: 'CubicIn',
          disabled: false
        },
        {
          id: 'c7563056-c8fa-468d-b1b2-5bd69f57e657',
          type: 'Tween',
          name: 'livesScalePosition_1_copy_1',
          duration: 200,
          track: 17,
          target: {
            scale: {
              x: 1.04,
              y: 1.08
            },
            y: -12
          },
          startAt: 50,
          sourceName: 'moreLivesImage',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f267b06b-b85c-4a7d-9cfa-9a82773fc9b7',
          type: 'Tween',
          name: 'moneyScalePosition_1',
          duration: 200,
          track: 19,
          target: {
            scale: {
              x: 1.04,
              y: 1.08
            },
            y: -3
          },
          startAt: 50,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '401b0394-050a-4264-bd8b-21c92bed9a2b',
          type: 'Tween',
          name: 'glowAlpha_1',
          duration: 300,
          track: 8,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'glow2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c553c725-507e-47b8-bb70-8485d657b10b',
          type: 'Tween',
          name: 'raysAlpha_1',
          duration: 300,
          track: 5,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'rays',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '7d0e3356-70c7-46e3-9e38-bd5471057eae',
          type: 'Tween',
          name: 'premiumTitleAlpha_1',
          duration: 300,
          track: 15,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'getPremiumTitleText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ff4cb1e4-5ac7-474c-a263-9ff5e1496c59',
          type: 'Tween',
          name: 'premiumDescriptionAlpha_1_copy',
          duration: 300,
          track: 13,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'getPremiumDescriptionText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '34dedf97-2ed1-45d8-8a5a-0aac8f6d538e',
          type: 'Tween',
          name: 'bonusTitleAlpha_1',
          duration: 300,
          track: 12,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'bonusTitleText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '675f84cd-1da6-42be-9304-e0556eaae8e6',
          type: 'Tween',
          name: 'bonusDescriptionAlpha',
          duration: 300,
          track: 11,
          target: {
            alpha: 0
          },
          startAt: 150,
          sourceName: 'bonusDescriptionText',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '11e188a0-b236-42e0-a346-d3f52631ea5c',
          type: 'Tween',
          name: 'floorAlpha_1',
          duration: 300,
          track: 10,
          target: {
            alpha: 0
          },
          startAt: 200,
          sourceName: 'floor',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '0e344d9f-9cf6-4189-85f1-f6aad5f014ce',
          type: 'Tween',
          name: 'seasonPassImageAlpha',
          duration: 300,
          track: 3,
          target: {
            alpha: 0
          },
          startAt: 200,
          sourceName: 'seasonPassImage',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9a586ccc-0d54-4503-8b16-abf5e7a8aa53',
          type: 'Tween',
          name: 'closeButtonShadowScale_1_1_copy_1_copy',
          duration: 200,
          track: 21,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 200,
          sourceName: 'closeButtonShadow',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '23fb919c-f97e-45a0-9b73-f0466abc109d',
          type: 'Tween',
          name: 'ButtonScale_1_1_copy_1_copy',
          duration: 200,
          track: 23,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 200,
          sourceName: 'button',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '6b52a50b-ae40-45ea-8ae8-5fd2fce02706',
          type: 'Tween',
          name: 'closeButtonScale_1_1_copy',
          duration: 200,
          track: 24,
          target: {
            scale: {
              x: 0,
              y: 0
            }
          },
          startAt: 200,
          sourceName: 'closeButton',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'df839a51-a14d-4872-be94-4639e954c271',
          type: 'Tween',
          name: 'floorAlpha_1_copy',
          duration: 300,
          track: 9,
          target: {
            alpha: 0
          },
          startAt: 200,
          sourceName: 'floor2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '86f9c5e6-349e-4284-b110-8b4dbd627595',
          type: 'Tween',
          name: 'livesScalePosition_1_copy_1_copy',
          duration: 200,
          track: 17,
          target: {
            scale: {
              x: 0,
              y: 0
            },
            y: 157
          },
          startAt: 250,
          sourceName: 'moreLivesImage',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'd19ea611-8a68-4c9c-9ac9-5f5c6da25831',
          type: 'Tween',
          name: 'moneyScalePosition_1_copy',
          duration: 200,
          track: 19,
          target: {
            scale: {
              x: 0,
              y: 0
            },
            y: -38
          },
          startAt: 250,
          sourceName: 'moneyMountain',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'f5b9d23b-9bad-4675-8a51-01d21030a2d3',
          type: 'Tween',
          name: 'gradientAlpha_1',
          duration: 290,
          track: 2,
          target: {
            alpha: 0
          },
          startAt: 310,
          sourceName: 'gradient',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '04676b8a-6fd8-4d13-85be-8e27414dd614',
          type: 'Tween',
          name: 'gradientAlpha_1_copy_1',
          duration: 290,
          track: 1,
          target: {
            alpha: 0
          },
          startAt: 310,
          sourceName: 'gradient2',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '57f9d7fd-4c33-43d4-bbfe-433dd12d33db',
          type: 'Tween',
          name: 'closeButtonShadowScale_1_1_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1542,
          sourceName: 'closeButtonShadow',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassActivatePremiumLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  gradient!: Sprite & { data: typeof raw['list'][1]['data'] };
  gradient2!: Sprite & { data: typeof raw['list'][2]['data'] };
  closeButtonShadow!: Sprite;
  seasonPassImage!: Sprite;
  rewards!: Container;
  moneyMountain!: Container;
  premiumRewardsSlot!: Container;
  getPremiumTitleText!: Text & { data: typeof raw['list'][8]['data'] };
  getPremiumDescriptionText!: Text;
  bonusTitleText!: Text;
  bonusDescriptionText!: Text & { data: typeof raw['list'][11]['data'] };
  closeButton!: Sprite;
  moreLivesImage!: Container;
  button!: ButtonExtraLargeLayout & { data: typeof raw['list'][14]['data'] };
  shine1!: Sprite;
  shine2!: Sprite;
  shine3!: Sprite;
  shine4!: Sprite;
  shine5!: Sprite;
  shine6!: Sprite;
  valueBadge!: Container;
  glow1!: Sprite;
  splash!: Sprite;
  arrow!: Sprite;
  heart!: Sprite;
  heart2!: Sprite;
  buttonGlow!: Sprite;
  price!: Text;
  5!: Text;
  heartShine!: Sprite;
  8!: Text;
  dynamicProps_SPL!: (Container & { data: typeof raw['list'][0]['data'] } | Sprite & { data: typeof raw['list'][1]['data'] } | Sprite & { data: typeof raw['list'][2]['data'] })[];
  colorTags_SPL!: (Text & { data: typeof raw['list'][8]['data'] } | Text & { data: typeof raw['list'][11]['data'] })[];
  rotate_SPL!: (Sprite)[];
  variable_SPL!: (Text)[];
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}

export abstract class Appearing {
  Layout: {
    gradient: object;
    seasonPassImage: object;
    floor: object;
    rays: object;
    glow2: object;
    getPremiumTitleText: object;
    getPremiumDescriptionText: object;
    bonusTitleText: object;
    bonusDescriptionText: object;
    moneyMountain: object;
    moreLivesImage: object;
    closeButton: object;
    closeButtonShadow: object;
    button: object;
    floor2: object;
    gradient2: object;
    rewards: object;
    premiumRewardsSlot: object;
    valueBadge: object;
  };

  BlockTypeByName: {
    gradientAlpha: object;
    seasonPassImageAlpha: object;
    floorAlpha: object;
    raysAlpha: object;
    glowAlpha: object;
    premiumTitleAlpha: object;
    premiumDescriptionAlpha_copy: object;
    bonusTitleAlpha: object;
    bonusDescriptionAlpha_copy: object;
    moneyScalePosition: object;
    livesScalePosition_copy: object;
    closeButtonScale: object;
    closeButtonShadowScale_copy: object;
    closeButtonScale_copy: object;
    floorAlpha_copy: object;
    gradientAlpha_copy: object;
    rewardsAlpha: object;
    rewardsSlot: object;
    valueBadgeSetter: object;
    gradientAlpha_1: object;
    gradientAlpha_1_copy: object;
    floorAlpha_1: object;
    seasonPassImageAlpha: object;
    floorAlpha_1_copy_1: object;
    moneyScalePosition_1: object;
    glow2Alpha_1: object;
    raysAlpha_1: object;
    premiumTitleAlpha_1: object;
    premiumDescriptionAlpha_1_copy: object;
    bonusTitleAlpha_1: object;
    bonusDescriptionAlpha: object;
    livesScalePosition_1_copy_1: object;
    New_tween_1: object;
    New_tween: object;
    closeButtonScale_1_1: object;
    closeButtonShadowScale_1_1_copy_1: object;
    ButtonScale_1_1_copy_1: object;
    livesScalePosition_1_copy_1_copy: object;
    moneyScalePosition_1_copy: object;
    New_tween_3_1: object;
    ButtonScale_1_1_copy_1_copy: object;
    closeButtonShadowScale_1_1_copy_1_copy: object;
    closeButtonScale_1_1_copy: object;
    closeButtonShadowScale_1_1_copy_copy: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle {
  Layout: {
    moneyMountain: object;
    button: object;
    buttonGlow: object;
    shine6: object;
    shine5: object;
    shine4: object;
    shine3: object;
    shine2: object;
    shine1: object;
    heart2: object;
    heartShine: object;
  };

  BlockTypeByName: {
    moneyScalePosition_2: object;
    buttonScale: object;
    buttonGlowAlpha: object;
    shine6AlphaScale: object;
    shine6AlphaScale_1: object;
    shine6AlphaScale_copy_1: object;
    shine5AlphaScale_copy: object;
    shine5AlphaScale_1_copy: object;
    shine6AlphaScale_copy_1_copy: object;
    shine4AlphaScale_copy_copy: object;
    shine4AlphaScale_1_copy_copy: object;
    buttonGlowAlpha_copy: object;
    buttonScale_copy: object;
    moneyScalePosition_2_copy: object;
    shine6AlphaScale_copy_1_copy_copy: object;
    shine3AlphaScale_copy_copy_copy: object;
    shine3AlphaScale_1_copy_copy_copy: object;
    shine6AlphaScale_copy_1_copy_copy_copy: object;
    shine2AlphaScale_copy_copy_copy_copy: object;
    shine2AlphaScale_1_copy_copy_copy_copy: object;
    shine6AlphaScale_copy_1_copy_copy_copy_copy: object;
    shine1AlphaScale_copy_copy_copy_copy_copy: object;
    shine1AlphaScale_1_copy_copy_copy_copy_copy: object;
    buttonGlowAlpha_copy_1: object;
    buttonScale_copy_1: object;
    heartScale_3: object;
    heartShineAlpha: object;
    moneyScalePosition_2_copy_1: object;
    shine6AlphaScale_copy_1_copy_copy_copy_copy_copy: object;
    shine6AlphaScale_copy: object;
    shine6AlphaScale_1_copy: object;
    shine6AlphaScale_copy_copy: object;
    shine5AlphaScale_copy_copy: object;
    heartScale_1: object;
    heartShineAlpha_copy: object;
    shine5AlphaScale_1_copy_copy: object;
    shine6AlphaScale_copy_copy_copy: object;
    shine4AlphaScale_copy_copy_copy: object;
    shine4AlphaScale_1_copy_copy_copy: object;
    buttonGlowAlpha_copy_copy: object;
    buttonScale_copy_copy: object;
    heartScale: object;
    heartShineAlpha_copy_1: object;
    moneyScalePosition_2_copy_copy: object;
    shine6AlphaScale_copy_copy_copy_copy: object;
    shine3AlphaScale_copy_copy_copy_copy: object;
    shine3AlphaScale_1_copy_copy_copy_copy: object;
    shine6AlphaScale_copy_copy_copy_copy_copy: object;
    shine2AlphaScale_copy_copy_copy_copy_copy: object;
    heartScale_2: object;
    heartShineAlpha_copy_copy: object;
    shine2AlphaScale_1_copy_copy_copy_copy_copy: object;
    shine6AlphaScale_copy_copy_copy_copy_copy_copy: object;
    shine1AlphaScale_copy_copy_copy_copy_copy_copy: object;
    shine1AlphaScale_1_copy_copy_copy_copy_copy_copy: object;
    shine6AlphaScale_copy_copy_copy_copy_copy_copy_copy: object;
  };

  flowData = raw.animations[1];
}

export abstract class Disappearing {
  Layout: {
    gradient: object;
    floor: object;
    glow2: object;
    seasonPassImage: object;
    rays: object;
    bonusDescriptionText: object;
    bonusTitleText: object;
    getPremiumDescriptionText: object;
    getPremiumTitleText: object;
    floor2: object;
    gradient2: object;
    closeButtonShadow: object;
    button: object;
    closeButton: object;
    rewards: object;
    premiumRewardsSlot: object;
    valueBadge: object;
    moreLivesImage: object;
    moneyMountain: object;
  };

  BlockTypeByName: {
    gradientAlpha: object;
    New_setter_copy: object;
    glow2Alpha: object;
    seasonPassImageAlpha: object;
    raysAlpha: object;
    New_setter_copy_copy_1: object;
    New_setter_copy_copy_2: object;
    New_setter_copy_copy_3: object;
    New_setter_copy_copy_4: object;
    floor2Alpha: object;
    gradientAlpha_copy_1: object;
    closeButtonShadowScale_1_1_copy_1: object;
    ButtonScale_1_1_copy_1: object;
    closeButtonScale_1_1: object;
    New_tween_2: object;
    New_tween_2_copy_1: object;
    New_tween_2_copy: object;
    livesScalePosition_1_copy_1: object;
    moneyScalePosition_1: object;
    glowAlpha_1: object;
    raysAlpha_1: object;
    premiumTitleAlpha_1: object;
    premiumDescriptionAlpha_1_copy: object;
    bonusTitleAlpha_1: object;
    bonusDescriptionAlpha: object;
    floorAlpha_1: object;
    seasonPassImageAlpha: object;
    closeButtonShadowScale_1_1_copy_1_copy: object;
    ButtonScale_1_1_copy_1_copy: object;
    closeButtonScale_1_1_copy: object;
    floorAlpha_1_copy: object;
    livesScalePosition_1_copy_1_copy: object;
    moneyScalePosition_1_copy: object;
    gradientAlpha_1: object;
    gradientAlpha_1_copy_1: object;
    closeButtonShadowScale_1_1_copy_copy: object;
  };

  flowData = raw.animations[2];
}
